export default __webpack_public_path__ + "static/media/Logo.7beaee96.svg";